<template>
  <div >
    <div v-if="OpenClose" class="modal show"
         tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog"
         style="display:block">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <p class="text-center">{{msg}}</p>
          </div>
          <div class="modal-footer">
            <slot name="success" />
            <slot name="declined"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue';

const props = defineProps({
  visible: Boolean,
  msg: {
    type: String,
    required: true
  },
});

const OpenClose = ref(props.visible);

watch(props.visible, (newVal) => {
  OpenClose.value = newVal;
});
</script>